import {DescriptiveKPIAdditions, KPI, KPIGroupKey} from '../kpi';
import {DateRange} from '../stores/TimeIntervalStore';
import {CompareMode} from '../stores/CompareStore';
import {ProductDiagramInstruction, SearchDiagramInstruction} from '../stores/OdtExportStore';

export enum TableSortDirection {
    ASC = 'ASC',
    DESC = 'DESC',
}

export const tSortDirection = (sortDirection: TableSortDirection): string => {
    return sortDirection === TableSortDirection.ASC ? 'table:ascending' : 'table:descending';
};

export const isTableSortDirection = (value: any): value is TableSortDirection => {
    return Object.values(TableSortDirection).indexOf(value) > -1;
};

export interface TableSort {
    attribute: KPI | KPIGroupKey | DescriptiveKPIAdditions;
    targetName?: string;
    compareMode?: CompareMode;
    sortDirection: TableSortDirection;
}

export interface OdtReportBuildInstructions {
    targetCurrency: string;
    header: string;
    footer: string;
    heading: string;
    interval: DateRange;
    searchDiagrams: SearchDiagramInstruction[];
    productDiagrams: ProductDiagramInstruction[];
}



// WEBPACK FOOTER //
// ./src/types/Table.ts